<auth-splash-page>
  @if (colorMode.currentMode() === 'dark') {
    <img
      src="/assets/img/compass-logo-dark.png"
      class="align-self-center"
      alt="Compass logo"
      width="245"
      height="245"
    />
    <img src="/assets/img/brand-text-dark.png" class="mb-3" alt="CRST Compass" width="304" height="54" />
  } @else {
    <img src="/assets/img/compass-logo.png" class="align-self-center" alt="Compass logo" width="245" height="245" />
    <img src="/assets/img/brand-text.png" class="mb-3" alt="CRST Compass" width="304" height="54" />
  }
  <form #loginForm="ngForm" class="d-flex flex-column mb-3" (ngSubmit)="loginEmail()">
    <mat-form-field [hideRequiredMarker]="true">
      <mat-label>Email address</mat-label>
      <input matInput type="email" [(ngModel)]="emailAddress" name="username" autocomplete="username" required />
    </mat-form-field>
    <mat-form-field [hideRequiredMarker]="true">
      <mat-label>Password</mat-label>
      <input matInput type="password" [(ngModel)]="password" name="password" autocomplete="current-password" required />
    </mat-form-field>
    <button matButton="filled" [disabled]="loginForm.invalid">Login</button>
    <a routerLink="/forgot-password" class="mat-body-small align-self-center mt-2">Forgot password?</a>
  </form>
  <button class="employee-button align-self-center" (click)="loginEmployee()">CRST Employee Login</button>
</auth-splash-page>
